import {UiServiceV2} from '@gongxigames/framework/slotV2/baseClasses/uiServiceV2/UIServiceV2';
import {ScrollToFullscreen} from '@gongxigames/framework/slot';

export class IOSFullscreenService extends UiServiceV2 {
    public static NAME = Symbol('IOSFullscreenService');
    protected _isScrollHidden = false;

    protected onSetupEvents(): void {
        super.onSetupEvents();
        this.emitter.on('UI.IOSScroll.Activate', this.onActivateScroll.bind(this));
        this.emitter.on('UI.IOSScroll.Deactivate', this.onDeactivateScroll.bind(this));
        this.emitter.on('CORE.screen.resize', this.onResize.bind(this));
    }

    protected onActivateScroll(): void {
        this._isScrollHidden = false;
        this.checkScroll();
    }

    protected onDeactivateScroll(): void {
        this._isScrollHidden = true;
        this.hideScroll();
    }

    protected showScroll(): void {
        this.emitter.emit('UI.IOSScroll.Show');
    }

    protected hideScroll(): void {
        this.emitter.emit('UI.IOSScroll.Hide');
    }

    protected onResize(): void {
        this.checkScroll();
    }

    protected checkScroll(): void {
        if (ScrollToFullscreen.isFullscreen()) {
            this.hideScroll();
        } else if (!this._isScrollHidden) {
            this.showScroll();
        }
    }
}
